import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'session-status-dialog',
	templateUrl: './session-status-dialog.component.html',
	styleUrls: ['./session-status-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		TranslateModule,
		A11yModule
	]
})
export class SessionStatusDialogComponent {
	constructor (
		public dialogRef: GoDialogRef,
		@Inject(GO_MODAL_DATA) public data: {
			message: string;
		}
	) {}
}
